import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { createPackageSlice, PackageSlice } from './slices/packageSlice';
import { createCalculationSlice, CalculationSlice } from './slices/calculationSlice';
import { createPreferencesSlice, PreferencesSlice } from './slices/preferencesSlice';
import { createHistorySlice, HistorySlice } from './slices/historySlice';

export type StoreState = PackageSlice & CalculationSlice & PreferencesSlice & HistorySlice;

export const useAppStore = create<StoreState>()(
  persist(
    (...a) => ({
      ...createPackageSlice(...a),
      ...createCalculationSlice(...a),
      ...createPreferencesSlice(...a),
      ...createHistorySlice(...a),
    }),
    {
      name: 'freight-cbm-store',
      version: 1,
      partialize: (state) => ({
        packages: state.packages,
        mode: state.mode,
        dimDivisor: state.dimDivisor,
        divisorOverridden: state.divisorOverridden,
        costInput: state.costInput,
        preferences: state.preferences,
        calculations: state.calculations,
      }),
    },
  ),
);
